import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type React from "react";
interface FlagProps extends React.SVGAttributes<SVGSVGElement> {
  size?: string;
  className?: string;
}
const SwedenFlag: React.FC<FlagProps> = t0 => {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "40px" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = clsx("icon", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="#006AA7" d="M15.5 31H32c2.209 0 4-1.791 4-4.5v-6H15.5V31zM32 5H15.5v10.5H36V9a4 4 0 0 0-4-4zM10.5 5H4a4 4 0 0 0-4 3.997V15.5h10.5V5zM0 20.5v6.004C.002 29.211 1.792 31 4 31h6.5V20.5H0z" />;
    t4 = <path fill="#FECC00" d="M15.5 5h-5v10.5H0v5h10.5V31h5V20.5H36v-5H15.5z" />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== size || $[10] !== t2) {
    t5 = <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className={t2} preserveAspectRatio="xMidYMid meet" {...props}>{t3}{t4}</svg>;
    $[8] = props;
    $[9] = size;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default SwedenFlag;